import colors from 'styles/colors-export.css'

export default style => {
  if (style === 'dark') {
    return {
      background: colors.primary,
      text: 'white',
    }
  } else if (style === 'light') {
    return {
      background: 'rgba(0, 0, 0, 0.05)',
      text: 'black',
    }
  } else if (style === 'accent') {
    return {
      background: colors.accent,
      text: 'white',
    }
  }
  return {
    background: 'white',
    text: 'black',
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Utils/getDetailFromColor.js